import * as Sentry from "@sentry/react";
import { toast } from "@/hooks/use-toast";

/**
 * One place to fail loudly: console, Sentry, and a word to her.
 *
 * Shared because this app's defining bug class is the write that quietly does
 * nothing — an analytics pipeline whose every flush failed into an empty catch,
 * a share sheet that confirmed and published nothing, grocery taps that just
 * didn't move. Every one of those looked like success. A failed write must cost
 * the user a sentence, not a silent no-op.
 *
 * `subsystem` tags the Sentry event so failures can be grouped by surface.
 */
export function reportWriteFailure(
  subsystem: string,
  what: string,
  err: unknown,
  title: string,
  description: string,
): void {
  console.error(`[${subsystem}] ${what} failed`, err);
  Sentry.captureException(err, { tags: { subsystem } });
  toast({ variant: "destructive", title, description });
}
